import { gridRect, SURF_GRID_LEFT_COL, SURF_GRID_RIGHT_COL } from "./layoutGrid.js";
const BIG_NUMBER_SLOTS = [
    { role: "number", rect: gridRect(2, 3, 17, 7), textRole: "title" },
    { role: "label", rect: gridRect(3, 11, 15, 3), textRole: "subtitle" },
    { role: "context", rect: gridRect(2, 15, 17, 4), textRole: "body" },
];
export const SURF_LAYOUT_CATALOG = [
    {
        id: "cover",
        title: "Cover",
        description: "Titolo hero centrato",
        slots: [
            { role: "title", rect: gridRect(0, 5, 21, 5), textRole: "title" },
            { role: "subtitle", rect: gridRect(2, 11, 17, 2), textRole: "subtitle" },
        ],
    },
    {
        id: "section",
        title: "Section",
        description: "Divider di sezione",
        slots: [
            { role: "kicker", rect: gridRect(0, 6, 21, 2), textRole: "kicker" },
            { role: "title", rect: gridRect(0, 9, 21, 5), textRole: "title" },
        ],
    },
    {
        id: "title-body",
        title: "Title + Body",
        description: "Titolo e corpo classico",
        slots: [
            { role: "title", rect: gridRect(0, 0, 21, 4), textRole: "title" },
            { role: "body", rect: gridRect(0, 5, 21, 14), textRole: "body" },
        ],
    },
    {
        id: "bullets",
        title: "Bullets",
        description: "Titolo e elenco puntato",
        slots: [
            { role: "title", rect: gridRect(0, 0, 21, 3), textRole: "title" },
            { role: "bullets", rect: gridRect(1, 4, 19, 15), textRole: "bullet" },
        ],
    },
    {
        id: "two-column",
        title: "Two column",
        description: "Due colonne di testo",
        slots: [
            { role: "title", rect: gridRect(0, 0, 21, 3), textRole: "title" },
            { role: "left", rect: { ...SURF_GRID_LEFT_COL, y: 0.28, h: 0.64 }, textRole: "body" },
            { role: "right", rect: { ...SURF_GRID_RIGHT_COL, y: 0.28, h: 0.64 }, textRole: "body" },
        ],
    },
    {
        id: "image-left",
        title: "Image left",
        description: "Immagine a sinistra, testo a destra",
        slots: [
            { role: "image", rect: gridRect(0, 1, 10, 17), textRole: "caption" },
            { role: "title", rect: { ...SURF_GRID_RIGHT_COL, y: 0.16, h: 0.16 }, textRole: "title" },
            { role: "body", rect: { ...SURF_GRID_RIGHT_COL, y: 0.36, h: 0.52 }, textRole: "body" },
        ],
    },
    {
        id: "quote",
        title: "Full-bleed quote",
        description: "Citazione grande centrata",
        slots: [
            { role: "quote", rect: gridRect(0, 4, 21, 11), textRole: "title" },
            { role: "attribution", rect: gridRect(4, 16, 13, 2), textRole: "caption" },
        ],
    },
    {
        id: "kpi",
        title: "Big number / KPI",
        description: "Numero grande e didascalia",
        slots: BIG_NUMBER_SLOTS,
    },
    {
        id: "big-number",
        title: "Big number",
        description: "Statistica o KPI in evidenza",
        slots: BIG_NUMBER_SLOTS,
    },
    {
        id: "comparison",
        title: "Comparison",
        description: "Confronto due opzioni",
        slots: [
            { role: "title", rect: gridRect(0, 0, 21, 3), textRole: "title" },
            { role: "option_a", rect: { ...SURF_GRID_LEFT_COL, y: 0.28, h: 0.58 }, textRole: "body" },
            { role: "option_b", rect: { ...SURF_GRID_RIGHT_COL, y: 0.28, h: 0.58 }, textRole: "body" },
        ],
    },
    {
        id: "closing",
        title: "Closing",
        description: "Chiusura con CTA",
        slots: [
            { role: "title", rect: gridRect(1, 5, 19, 5), textRole: "title" },
            { role: "cta", rect: gridRect(4, 11, 13, 2), textRole: "kicker" },
            { role: "body", rect: gridRect(2, 14, 17, 5), textRole: "body" },
        ],
    },
];
const LAYOUT_ALIASES = {
    "title-image-right": "image-left",
    "comparison-columns": "comparison",
};
export function normalizeLayoutId(id) {
    const trimmed = id.trim();
    return LAYOUT_ALIASES[trimmed] ?? trimmed;
}
export function getSurfLayout(id) {
    const normalized = normalizeLayoutId(id);
    return SURF_LAYOUT_CATALOG.find((l) => l.id === normalized);
}
export function layoutCatalogForPrompt() {
    const seen = new Set();
    const lines = [];
    for (const l of SURF_LAYOUT_CATALOG) {
        if (l.id === "kpi")
            continue;
        if (seen.has(l.id))
            continue;
        seen.add(l.id);
        lines.push(`- ${l.id}: ${l.title} — ${l.description}; slots: ${l.slots.map((s) => s.role).join(", ")}`);
    }
    return lines.join("\n");
}
export function isKnownLayoutId(id) {
    return Boolean(getSurfLayout(id));
}
